import { merge } from 'lodash';
import { UploadMachine } from '~/machines/upload';
import { ContextSendMatch } from '~/machines/utils/types';
import { DeepPartial } from '~/typings/utils';
import {
  LMIProofDocsUpload,
  LMIProofDocsUploadProps,
} from './component/lmi-proof-docs-upload.component';

type LMIProofDocsUploadContainerProps = {
  micro: ContextSendMatch<UploadMachine>;
  overrideCopy?: LMIProofDocsUploadProps['overrideCopy'];
  overrideProps?: DeepPartial<LMIProofDocsUploadProps>;
};

export const LMIProofDocsUploadContainer = ({
  micro: { context, matches, send },
  overrideCopy,
  overrideProps,
}: LMIProofDocsUploadContainerProps) => {
  const props: LMIProofDocsUploadProps = {
    context,
    next: docs => send({ type: 'SUBMIT_DOCS', data: { docs } }),
    skip: () => send({ type: 'SKIP' }),
    overrideCopy,
    pending: !matches('idle'),
    loading: matches('submitting'),
  };

  return <LMIProofDocsUpload {...merge(props, overrideProps)} />;
};
